import { useState } from "react";
import expenseTrackerPc from "../assets/expensetrackerpc.png";
import cluifyPc from "../assets/cluifypc.png";
import { renderButtons } from "./portfolio/PortfolioButtonRender";
// import empty from "../assets/emptyimage.png"

const Portfolio = () => {
  const projects = [
    {
      id: 1,
      title: "Expense Tracker",
      image: expenseTrackerPc,
      demoUrl: "https://asantaes-expense-tracker.netlify.app/",
      frontendUrl: "https://github.com/Asantae/expense-tracker-frontend",
      backendUrl: "https://github.com/Asantae/ExpenseTrackerBackend",
      description:
        "This app allows users to register, log in, and manage their expenses by adding, removing, and editing entries. It provides a clear and organized record of personal spending for effective financial tracking.",
      tech: ["React/Typescript", ".NET", "C#", "SQLite", "Azure App Service"]
    },
    {
      id: 2,
      title: "Cluify",
      image: cluifyPc,
      demoUrl: "https://cluify.net/",
      codeUrl: "https://github.com/Asantae/Cluify",
      description: "This is a game that allows players to investigate suspicious person reports by analyzing clues and evidence, then deciding whether to file or shred each report. It provides an engaging, puzzle-like crime-solving experience with a daily challenge and dynamic scoring system.",
      tech: ["React/Typescript", "expressjs", "nodejs", "MongoDB", "AWS"]
    },
    // Add more projects as needed...
  ];

  const [selectedProject, setSelectedProject] = useState(null);

  const openModal = (project) => setSelectedProject(project);
  const closeModal = () => setSelectedProject(null);

  return (
    <div name="portfolio" id="portfolio" className="w-full min-h-screen bg-[#0a192f] p-4 text-white">
      <div className="max-w-screen-lg mx-auto flex flex-col justify-center">
        <div className="pb-8">
          <h2 className="text-4xl font-bold inline border-b-4 border-pink-600">Portfolio</h2>
          <p className="text-gray-400 py-4">Check out some of my work. *Click the image to see the summary:</p>
        </div>

        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-8">
          {projects.map((project) => (
            <div key={project.id} className="bg-gray-800 shadow-md rounded-lg overflow-hidden">
              <img
                src={project.image}
                alt={project.title}
                className="w-full h-48 object-cover duration-200 hover:scale-105 cursor-pointer"
                onClick={() => openModal(project)}
              />
              <div className="py-4 px-2">
                <h3 className="text-xl font-semibold mb-2">{project.title}</h3>
                <div>{renderButtons(project)}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Modal for Project Details */}
      {selectedProject && (
        <div
          onClick={closeModal}
          className="fixed inset-0 bg-black bg-opacity-75 flex justify-center items-center z-50"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="bg-[#0a192f] p-6 rounded-lg w-11/12 sm:w-full max-w-3xl relative max-h-screen overflow-y-auto"
          >
            <button
              onClick={closeModal}
              className="absolute top-2 right-2 text-white text-3xl font-bold hover:text-pink-600"
            >
              &times;
            </button>
            <h3 className="text-2xl font-bold mb-4">{selectedProject.title}</h3>
            <img
              src={selectedProject.image}
              alt={selectedProject.title}
              className="w-full h-auto object-contain mb-4 rounded"
            />
            <p className="text-gray-300 mb-4">{selectedProject.description}</p>
            {/* Technologies Section */}
            {selectedProject.tech && selectedProject.tech.length > 0 && (
              <div className="mb-4">
                <h4 className="text-xl font-semibold">Tech Used:</h4>
                <ul className="list-disc ml-6">
                  {selectedProject.tech.map((tech, index) => (
                    <li key={index} className="text-gray-300">
                      {tech}
                    </li>
                  ))}
                </ul>
              </div>
            )}
            <div>{renderButtons(selectedProject)}</div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Portfolio;